module.exports = __webpack_public_path__ + "img/suspicious_email_banner.9a457ecb.png";